import React from 'react';
import FileTrace from './FileTrace'
import FileTraceGM from './FileTraceGM'

let accessType = {
    END_USER :'END_USER',
    CORPORATE : 'CORPORATE',
    ONBOARDING_TEAM : 'ONBOARDING_TEAM'
};

class FileTraceRouter extends React.Component{
    render(){
        return (this.props.accessType != accessType.END_USER)?
            (<FileTraceGM 
                user={this.props.user} 
                match={this.props.match} 
                accessType={this.props.accessType} 
                permitExtraDetails={this.props.permitExtraDetails} 
                solutions={this.props.solutions}  
            />):
            (<FileTrace 
                user={this.props.user} 
                match={this.props.match} 
                accessType={this.props.accessType} 
                permitExtraDetails={this.props.permitExtraDetails} 
                solutions={this.props.solutions}
            />);
        //return <FileTrace user={this.props.user} match={this.props.match} permitExtraDetails={this.props.permitExtraDetails} />;
    }
}

export default FileTraceRouter;